import { FC, memo } from "react";

export const PageIcon: FC<{ className?: string }> = memo(({ className }) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="11.5"
      y="6.5"
      width="25"
      height="35"
      fill="#F4AA41"
      stroke="black"
      strokeLinejoin="round"
    />
    <rect
      x="26"
      y="16"
      width="7"
      height="8"
      fill="#9B9B9A"
      stroke="black"
      strokeLinejoin="round"
    />
    <path
      d="M14 16H24M14 20H24M14 24H24M14 28H34M14 32H34M14 36H34"
      stroke="black"
      strokeLinejoin="round"
    />
    <path d="M27 11H14" stroke="black" strokeWidth="2" strokeLinejoin="round" />
  </svg>
));
